import '@sparta.global.utilities/sparta-input-utility/dist/es6.js';
import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import spartaInputErrorUtility from '@sparta.global.utilities/sparta-input-error-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import Handlebars from '@sparta.global.vendors/handlebars';
import { textInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { is } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <style type=\"text/css\">\r\n    [data-sparta-container] .spa-input.spa-input--sparta2 .spa-input-error-message.soft-error {\r\n      color: $color-brand-primary;\r\n      background: url(\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"mortgage") : stack1)) != null ? lookupProperty(stack1,"warningImage") : stack1)) != null ? lookupProperty(stack1,"img") : stack1), depth0))
    + "\") no-repeat left top !important;\r\n      background-size: 20px 20px !important;\r\n      margin: .625rem 0 !important;\r\n      padding: 0 0 0 1.625rem !important;\r\n      border-color: green !important;\r\n      color: green !important;\r\n    }\r\n  </style>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <style type=\"text/css\">\r\n    [data-sparta-container] .spa-input.spa-input--sparta2 .spa-input-error-message.soft-error {\r\n      color: $color-brand-primary;\r\n      background: url(\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"refinance") : stack1)) != null ? lookupProperty(stack1,"warningImage") : stack1)) != null ? lookupProperty(stack1,"img") : stack1), depth0))
    + "\") no-repeat left top !important;\r\n      background-size: 20px 20px !important;\r\n      margin: .625rem 0 !important;\r\n      padding: 0 0 0 1.625rem !important;\r\n      border-color: green !important;\r\n      color: green !important;\r\n    }\r\n  </style>\r\n";
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <section class='"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":32,"column":22},"end":{"line":32,"column":30}}}) : helper)))
    + " wrapper-rates-table' data-route=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":32,"column":64},"end":{"line":32,"column":72}}}) : helper)))
    + "\" data-finance-type=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"financeType") || (depth0 != null ? lookupProperty(depth0,"financeType") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"financeType","hash":{},"data":data,"loc":{"start":{"line":32,"column":93},"end":{"line":32,"column":108}}}) : helper)))
    + "\">\r\n        <div class=\"row\">\r\n          <div class=\"medium-12 column\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"details") : depth0),{"name":"with","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":12},"end":{"line":129,"column":21}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"footer") : depth0),{"name":"with","hash":{},"fn":container.program(52, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":131,"column":12},"end":{"line":140,"column":21}}})) != null ? stack1 : "")
    + "          </div>\r\n        </div>\r\n      </section>\r\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"calculator") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":14},"end":{"line":74,"column":21}}})) != null ? stack1 : "")
    + "\r\n              <div class=\"table\">\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"local"))) && lookupProperty(stack1,"tableSummary")),{"name":"if","hash":{},"fn":container.program(25, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":77,"column":16},"end":{"line":77,"column":115}}})) != null ? stack1 : "")
    + "\r\n                <div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"headings") : depth0),{"name":"each","hash":{},"fn":container.program(27, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":79,"column":18},"end":{"line":95,"column":27}}})) != null ? stack1 : "")
    + "                </div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"terms") : depth0),{"name":"each","hash":{},"fn":container.program(33, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":98,"column":16},"end":{"line":127,"column":25}}})) != null ? stack1 : "")
    + "              </div>\r\n";
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n                <section class=\"medium-calculator\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"calculator") : depth0)) != null ? lookupProperty(stack1,"container1") : stack1),{"name":"with","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":18},"end":{"line":46,"column":27}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"calculator") : depth0)) != null ? lookupProperty(stack1,"container2") : stack1),{"name":"with","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":18},"end":{"line":72,"column":27}}})) != null ? stack1 : "")
    + "                </section>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"row medium-container1\">\r\n                      <div class=\"medium-12 medium-centered column\">\r\n                        <p>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n                      </div>\r\n                    </div>\r\n\r\n";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"row medium-container2 hide-calc\">\r\n                      <form id=\"form-medium-inputs\" class=\"row\" novalidate>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputsMedium") : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":50,"column":24},"end":{"line":61,"column":33}}})) != null ? stack1 : "")
    + "                        <div class=\""
    + ((stack1 = (lookupProperty(helpers,"ifArrayLength")||(depth0 && lookupProperty(depth0,"ifArrayLength"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputsMedium") : depth0),"3",{"name":"ifArrayLength","hash":{},"fn":container.program(19, data, 0, blockParams, depths),"inverse":container.program(21, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":62,"column":36},"end":{"line":62,"column":136}}})) != null ? stack1 : "")
    + " column medium-buttons-links\">\r\n                          <div>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"buttons") : depth0),{"name":"each","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":28},"end":{"line":66,"column":37}}})) != null ? stack1 : "")
    + "                            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"linkObj") : depth0)) != null ? lookupProperty(stack1,"medium") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                          </div>\r\n                        </div>\r\n                      </form>\r\n                    </div>\r\n";
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","CURRENCY-TYPE",{"name":"ifCond","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":51,"column":26},"end":{"line":55,"column":37}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","ZIP-TYPE",{"name":"ifCond","hash":{},"fn":container.program(17, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":26},"end":{"line":60,"column":37}}})) != null ? stack1 : "");
},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <div class=\""
    + ((stack1 = (lookupProperty(helpers,"ifArrayLength")||(depth0 && lookupProperty(depth0,"ifArrayLength"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"inputsMedium") : depths[1]),"3",{"name":"ifArrayLength","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.program(15, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":52,"column":40},"end":{"line":52,"column":167}}})) != null ? stack1 : "")
    + " column\">\r\n                              "
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":53,"column":30},"end":{"line":53,"column":50}}})) != null ? stack1 : "")
    + "\r\n                            </div>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    return "medium-4 large-3";
},"15":function(container,depth0,helpers,partials,data) {
    return "medium-4 medium-offset-2 large-3 large-offset-2";
},"17":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <div class=\""
    + ((stack1 = (lookupProperty(helpers,"ifArrayLength")||(depth0 && lookupProperty(depth0,"ifArrayLength"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"inputsMedium") : depths[1]),"3",{"name":"ifArrayLength","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.program(13, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":57,"column":40},"end":{"line":57,"column":136}}})) != null ? stack1 : "")
    + " column zip\">\r\n                              "
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":58,"column":30},"end":{"line":58,"column":50}}})) != null ? stack1 : "")
    + "\r\n                            </div>\r\n";
},"19":function(container,depth0,helpers,partials,data) {
    return "medium-12 large-3";
},"21":function(container,depth0,helpers,partials,data) {
    return "medium-12 large-4";
},"23":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                              <a class=\"spa-btn spa-btn--primary spa-btn--expand-on-small spa-btn--medium\" role=\"button\" href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "-medium\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"placeholder") : depth0), depth0))
    + "<span class=\"ada-hidden\"></span><span class=\"spin\"></span></a>\r\n";
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"ada-hidden\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"local"))) && lookupProperty(stack1,"tableSummary")), depth0))
    + "</span>";
},"27":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"medium-"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"span") : depth0), depth0))
    + " column\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text") : depth0),"==","",{"name":"ifCond","hash":{},"fn":container.program(28, data, 0),"inverse":container.program(30, data, 0),"data":data,"loc":{"start":{"line":81,"column":22},"end":{"line":93,"column":33}}})) != null ? stack1 : "")
    + "                    </div>\r\n";
},"28":function(container,depth0,helpers,partials,data) {
    return "                        <div class=\"container\">\r\n                          <div>\r\n                            <p>&nbsp;</p>\r\n                          </div>\r\n                        </div>\r\n";
},"30":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <div class=\"container\">\r\n                          <div scope=\"col\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? lookupProperty(stack1,"id") : stack1),{"name":"if","hash":{},"fn":container.program(31, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":89,"column":43},"end":{"line":89,"column":89}}})) != null ? stack1 : "")
    + ">\r\n                            <p class=\"cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? lookupProperty(stack1,"medium") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n                          </div>\r\n                        </div>\r\n";
},"31":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "id="
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0));
},"33":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <div class=\"row grayscale"
    + container.escapeExpression((lookupProperty(helpers,"getCustomObjectByKey")||(depth0 && lookupProperty(depth0,"getCustomObjectByKey"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"mediumLargeRowProps") : depths[1])) != null ? lookupProperty(stack1,"grayScale") : stack1),(data && lookupProperty(data,"index")),{"name":"getCustomObjectByKey","hash":{},"data":data,"loc":{"start":{"line":99,"column":43},"end":{"line":99,"column":112}}}))
    + "\" "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? lookupProperty(stack1,"dataAttr") : stack1), depth0)) != null ? stack1 : "")
    + ">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(34, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":100,"column":20},"end":{"line":125,"column":29}}})) != null ? stack1 : "")
    + "                  </div>\r\n";
},"34":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      <div class=\"medium-"
    + container.escapeExpression((lookupProperty(helpers,"getCustomArrayElement")||(depth0 && lookupProperty(depth0,"getCustomArrayElement"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[2] != null ? lookupProperty(depths[2],"headings") : depths[2]),(data && lookupProperty(data,"index")),0,"span",{"name":"getCustomArrayElement","hash":{},"data":data,"loc":{"start":{"line":101,"column":41},"end":{"line":101,"column":102}}}))
    + " column\">\r\n                        <div class=\"container\">\r\n                          <div "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"headers") : depth0),{"name":"if","hash":{},"fn":container.program(35, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":103,"column":31},"end":{"line":103,"column":85}}})) != null ? stack1 : "")
    + ">\r\n                            "
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),"==",0,{"name":"ifCond","hash":{},"fn":container.program(37, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":104,"column":28},"end":{"line":104,"column":120}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"linkObj") : depth0)) != null ? lookupProperty(stack1,"medium") : stack1),{"name":"if","hash":{},"fn":container.program(40, data, 0, blockParams, depths),"inverse":container.program(42, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":105,"column":28},"end":{"line":120,"column":35}}})) != null ? stack1 : "")
    + "                            "
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),"==",0,{"name":"ifCond","hash":{},"fn":container.program(50, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":121,"column":28},"end":{"line":121,"column":70}}})) != null ? stack1 : "")
    + "\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n";
},"35":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "header=\""
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"headers") : depth0), depth0)) != null ? stack1 : "")
    + "\"";
},"37":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div scope=\"row\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"id") : depth0),{"name":"if","hash":{},"fn":container.program(38, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":104,"column":70},"end":{"line":104,"column":108}}})) != null ? stack1 : "")
    + ">";
},"38":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "id="
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0)) != null ? stack1 : "");
},"40":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                              <p class=\"partial-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":106,"column":48},"end":{"line":106,"column":58}}}) : helper)))
    + "\">\r\n                                <span class='ada-hidden'>"
    + container.escapeExpression((lookupProperty(helpers,"getAdaHiddenMapping")||(depth0 && lookupProperty(depth0,"getAdaHiddenMapping"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[2] != null ? lookupProperty(depths[2],"adaHiddenMapping") : depths[2])) != null ? lookupProperty(stack1,"medium") : stack1),(data && lookupProperty(data,"key")),{"name":"getAdaHiddenMapping","hash":{},"data":data,"loc":{"start":{"line":107,"column":57},"end":{"line":107,"column":121}}}))
    + "</span>\r\n                                <span class='update-partial'>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n                              </p>\r\n                              <p class=\"custom-link cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"linkObj") : depth0)) != null ? lookupProperty(stack1,"medium") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"42":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"medium") : depth0),{"name":"if","hash":{},"fn":container.program(43, data, 0, blockParams, depths),"inverse":container.program(45, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":112,"column":30},"end":{"line":119,"column":37}}})) != null ? stack1 : "");
},"43":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                <p class=\"cnx-regular\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"medium") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"45":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                <p class=\"partial-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":115,"column":50},"end":{"line":115,"column":60}}}) : helper)))
    + "\">\r\n                                  <span class='ada-hidden'>"
    + container.escapeExpression((lookupProperty(helpers,"getAdaHiddenMapping")||(depth0 && lookupProperty(depth0,"getAdaHiddenMapping"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[2] != null ? lookupProperty(depths[2],"adaHiddenMapping") : depths[2])) != null ? lookupProperty(stack1,"medium") : stack1),(data && lookupProperty(data,"key")),{"name":"getAdaHiddenMapping","hash":{},"data":data,"loc":{"start":{"line":116,"column":59},"end":{"line":116,"column":123}}}))
    + "</span>\r\n                                  <span class='update-partial'>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text") : depth0),{"name":"if","hash":{},"fn":container.program(46, data, 0, blockParams, depths),"inverse":container.program(48, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":117,"column":63},"end":{"line":117,"column":120}}})) != null ? stack1 : "")
    + "</span>\r\n                                </p>\r\n";
},"46":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "");
},"48":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "");
},"50":function(container,depth0,helpers,partials,data) {
    return "</div>";
},"52":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <footer>\r\n                <div class='paras'>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"paras") : depth0),{"name":"each","hash":{},"fn":container.program(53, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":134,"column":18},"end":{"line":136,"column":27}}})) != null ? stack1 : "")
    + "                </div>\r\n                <p class=\"link\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"linkObj") : depth0)) != null ? lookupProperty(stack1,"medium") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n              </footer>\r\n";
},"53":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"55":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n      <section class='"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":150,"column":22},"end":{"line":150,"column":30}}}) : helper)))
    + " wrapper-rates-table  "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"details") : depth0)) != null ? lookupProperty(stack1,"smallScrollLayout") : stack1),{"name":"if","hash":{},"fn":container.program(56, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":150,"column":52},"end":{"line":150,"column":116}}})) != null ? stack1 : "")
    + "' data-route=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":150,"column":130},"end":{"line":150,"column":138}}}) : helper)))
    + "\">\r\n        <div class=\"row\">\r\n          <div class=\"small-12 column\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"details") : depth0),{"name":"with","hash":{},"fn":container.program(58, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":153,"column":12},"end":{"line":327,"column":21}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"footer") : depth0),{"name":"with","hash":{},"fn":container.program(107, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":329,"column":12},"end":{"line":338,"column":21}}})) != null ? stack1 : "")
    + "          </div>\r\n        </div>\r\n\r\n      </section>\r\n";
},"56":function(container,depth0,helpers,partials,data) {
    return "small-scroll-master";
},"58":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"calculator") : depth0),{"name":"if","hash":{},"fn":container.program(59, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":154,"column":14},"end":{"line":190,"column":21}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"smallScrollLayout") : depth0),{"name":"if","hash":{},"fn":container.program(68, data, 0, blockParams, depths),"inverse":container.program(90, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":192,"column":14},"end":{"line":326,"column":21}}})) != null ? stack1 : "");
},"59":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <section class=\"small-calculator\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"calculator") : depth0)) != null ? lookupProperty(stack1,"container1") : stack1),{"name":"with","hash":{},"fn":container.program(60, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":156,"column":18},"end":{"line":162,"column":27}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"calculator") : depth0)) != null ? lookupProperty(stack1,"container2") : stack1),{"name":"with","hash":{},"fn":container.program(62, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":163,"column":18},"end":{"line":188,"column":27}}})) != null ? stack1 : "")
    + "                </section>\r\n";
},"60":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"row small-container1\">\r\n                      <div class=\"small-12 column\">\r\n                        <p>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n                      </div>\r\n                    </div>\r\n";
},"62":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"row small-container2 hide-calc\">\r\n                      <form id=\"form-small-inputs\" class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputsSmall") : depth0),{"name":"each","hash":{},"fn":container.program(63, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":166,"column":24},"end":{"line":175,"column":33}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"buttons") : depth0),{"name":"each","hash":{},"fn":container.program(66, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":176,"column":24},"end":{"line":182,"column":33}}})) != null ? stack1 : "")
    + "                        <div class=\"small-12 column small-link\">\r\n                          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"linkObj") : depth0)) != null ? lookupProperty(stack1,"small") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                        </div>\r\n                      </form>\r\n                    </div>\r\n";
},"63":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <div class=\"small-12 column\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","CURRENCY-TYPE",{"name":"ifCond","hash":{},"fn":container.program(64, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":168,"column":28},"end":{"line":170,"column":39}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","ZIP-TYPE",{"name":"ifCond","hash":{},"fn":container.program(64, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":171,"column":28},"end":{"line":173,"column":39}}})) != null ? stack1 : "")
    + "                          </div>\r\n";
},"64":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                              "
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":169,"column":30},"end":{"line":169,"column":50}}})) != null ? stack1 : "")
    + "\r\n";
},"66":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <div class=\"small-12 column small-buttons\">\r\n                            <div class=\"column\">\r\n                              <a class=\"spa-btn spa-btn--primary spa-btn--expand-on-small spa-btn--small\" href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "-small\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"placeholder") : depth0), depth0))
    + "<span class=\"ada-hidden\"></span><span class=\"spin\"></span></a>\r\n                            </div>\r\n                          </div>\r\n";
},"68":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <section class=\"inner\">\r\n                  <div class=\"table small-scroll-layout left-show\">\r\n                    "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"local"))) && lookupProperty(stack1,"tableSummary")),{"name":"if","hash":{},"fn":container.program(25, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":195,"column":20},"end":{"line":195,"column":119}}})) != null ? stack1 : "")
    + "\r\n                    <div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"headings") : depth0),{"name":"each","hash":{},"fn":container.program(69, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":197,"column":22},"end":{"line":213,"column":31}}})) != null ? stack1 : "")
    + "                    </div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"terms") : depth0),{"name":"each","hash":{},"fn":container.program(77, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":216,"column":20},"end":{"line":245,"column":29}}})) != null ? stack1 : "")
    + "\r\n                    <div class=\"side-click-right\" tabindex=\"-1\" role=\"button\" aria-label=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"local"))) && lookupProperty(stack1,"chevronRight")), depth0))
    + "\">\r\n                      <div class=\"chevron\">\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"side-click-left\" tabindex=\"-1\" role=\"button\" aria-label=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"local"))) && lookupProperty(stack1,"chevronLeft")), depth0))
    + "\">\r\n                      <div class=\"chevron\">\r\n                      </div>\r\n                    </div>\r\n\r\n\r\n                  </div>\r\n                </section>\r\n\r\n\r\n";
},"69":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <div class=\"numbered "
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),"==",0,{"name":"ifCond","hash":{},"fn":container.program(70, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":198,"column":45},"end":{"line":198,"column":86}}})) != null ? stack1 : "")
    + " "
    + container.escapeExpression((lookupProperty(helpers,"arrayLastElement")||(depth0 && lookupProperty(depth0,"arrayLastElement"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"headings") : depths[1]),(data && lookupProperty(data,"index")),{"name":"arrayLastElement","hash":{},"data":data,"loc":{"start":{"line":198,"column":87},"end":{"line":198,"column":131}}}))
    + " column\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text") : depth0),"==","",{"name":"ifCond","hash":{},"fn":container.program(72, data, 0, blockParams, depths),"inverse":container.program(74, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":199,"column":26},"end":{"line":211,"column":37}}})) != null ? stack1 : "")
    + "                        </div>\r\n";
},"70":function(container,depth0,helpers,partials,data) {
    return "first";
},"72":function(container,depth0,helpers,partials,data) {
    return "                            <div class=\"container\">\r\n                              <div>\r\n                                <p>&nbsp;</p>\r\n                              </div>\r\n                            </div>\r\n";
},"74":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <div class=\"container\">\r\n                              <div scope=\"row\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? lookupProperty(stack1,"id") : stack1),{"name":"if","hash":{},"fn":container.program(75, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":207,"column":47},"end":{"line":207,"column":95}}})) != null ? stack1 : "")
    + ">\r\n                                  <p class=\"cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? lookupProperty(stack1,"small") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n                              </div>\r\n                            </div>\r\n";
},"75":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "id="
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0)) != null ? stack1 : "");
},"77":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      <div class=\"row grayscale"
    + container.escapeExpression((lookupProperty(helpers,"getCustomObjectByKey")||(depth0 && lookupProperty(depth0,"getCustomObjectByKey"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"smallRowProps") : depths[1])) != null ? lookupProperty(stack1,"grayScale") : stack1),(data && lookupProperty(data,"index")),{"name":"getCustomObjectByKey","hash":{},"data":data,"loc":{"start":{"line":217,"column":47},"end":{"line":217,"column":110}}}))
    + "\" "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? lookupProperty(stack1,"dataAttr") : stack1), depth0)) != null ? stack1 : "")
    + ">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(78, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":218,"column":24},"end":{"line":243,"column":33}}})) != null ? stack1 : "")
    + "                      </div>\r\n";
},"78":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <div class=\"numbered "
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),"==",0,{"name":"ifCond","hash":{},"fn":container.program(70, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":219,"column":47},"end":{"line":219,"column":88}}})) != null ? stack1 : "")
    + " "
    + container.escapeExpression((lookupProperty(helpers,"objectLastElement")||(depth0 && lookupProperty(depth0,"objectLastElement"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depths[1],(data && lookupProperty(data,"index")),{"name":"objectLastElement","hash":{},"data":data,"loc":{"start":{"line":219,"column":89},"end":{"line":219,"column":125}}}))
    + " column\">\r\n                            <div class=\"container\">\r\n                              <div "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"headers") : depth0),{"name":"if","hash":{},"fn":container.program(79, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":221,"column":35},"end":{"line":221,"column":88}}})) != null ? stack1 : "")
    + ">\r\n                                "
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),"==",0,{"name":"ifCond","hash":{},"fn":container.program(81, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":222,"column":32},"end":{"line":222,"column":125}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"linkObj") : depth0)) != null ? lookupProperty(stack1,"small") : stack1),{"name":"if","hash":{},"fn":container.program(83, data, 0, blockParams, depths),"inverse":container.program(85, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":223,"column":32},"end":{"line":238,"column":39}}})) != null ? stack1 : "")
    + "                                "
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),"==",0,{"name":"ifCond","hash":{},"fn":container.program(50, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":239,"column":32},"end":{"line":239,"column":74}}})) != null ? stack1 : "")
    + "\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n";
},"79":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "headers=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"headers") : depth0), depth0))
    + "\"";
},"81":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div scope=\"col\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"id") : depth0),{"name":"if","hash":{},"fn":container.program(38, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":222,"column":75},"end":{"line":222,"column":113}}})) != null ? stack1 : "")
    + ">";
},"83":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                  <p class=\"partial-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":224,"column":52},"end":{"line":224,"column":62}}}) : helper)))
    + "\">\r\n                                    <span class='ada-hidden'>"
    + container.escapeExpression((lookupProperty(helpers,"getAdaHiddenMapping")||(depth0 && lookupProperty(depth0,"getAdaHiddenMapping"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[2] != null ? lookupProperty(depths[2],"adaHiddenMapping") : depths[2])) != null ? lookupProperty(stack1,"smallScroll") : stack1),(data && lookupProperty(data,"key")),{"name":"getAdaHiddenMapping","hash":{},"data":data,"loc":{"start":{"line":225,"column":61},"end":{"line":225,"column":129}}}))
    + "</span>\r\n                                    <span class='update-partial'>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n                                  </p>\r\n                                  <p class=\"custom-link cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"linkObj") : depth0)) != null ? lookupProperty(stack1,"small") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"85":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"medium") : depth0),{"name":"if","hash":{},"fn":container.program(86, data, 0, blockParams, depths),"inverse":container.program(88, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":230,"column":34},"end":{"line":237,"column":41}}})) != null ? stack1 : "");
},"86":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                    <p class=\"cnx-regular\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"medium") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"88":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                    <p class=\"partial-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":233,"column":54},"end":{"line":233,"column":64}}}) : helper)))
    + "\">\r\n                                      <span class='ada-hidden'>"
    + container.escapeExpression((lookupProperty(helpers,"getAdaHiddenMapping")||(depth0 && lookupProperty(depth0,"getAdaHiddenMapping"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[2] != null ? lookupProperty(depths[2],"adaHiddenMapping") : depths[2])) != null ? lookupProperty(stack1,"smallScroll") : stack1),(data && lookupProperty(data,"key")),{"name":"getAdaHiddenMapping","hash":{},"data":data,"loc":{"start":{"line":234,"column":63},"end":{"line":234,"column":131}}}))
    + "</span>\r\n                                      <span class='update-partial'>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text") : depth0),{"name":"if","hash":{},"fn":container.program(46, data, 0, blockParams, depths),"inverse":container.program(48, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":235,"column":67},"end":{"line":235,"column":124}}})) != null ? stack1 : "")
    + "</span>\r\n                                    </p>\r\n";
},"90":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n                <div class=\"table small-regular-layout\">\r\n                  "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"local"))) && lookupProperty(stack1,"tableSummary")),{"name":"if","hash":{},"fn":container.program(25, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":264,"column":18},"end":{"line":264,"column":117}}})) != null ? stack1 : "")
    + "\r\n                  <div class=\"row headings\">\r\n                    <div class=\"small-3 column\">\r\n                      <div class=\"container\">\r\n                        <p>&nbsp;</p>\r\n                      </div>\r\n                    </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"terms") : depth0),{"name":"each","hash":{},"fn":container.program(91, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":271,"column":20},"end":{"line":281,"column":29}}})) != null ? stack1 : "")
    + "                  </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"smallRows") : depth0),{"name":"with","hash":{},"fn":container.program(94, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":283,"column":18},"end":{"line":324,"column":27}}})) != null ? stack1 : "")
    + "                </div>\r\n";
},"91":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      <div class=\"small-3 column\" "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? lookupProperty(stack1,"dataAttr") : stack1), depth0)) != null ? stack1 : "")
    + ">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"getCustomObjectPosition")||(depth0 && lookupProperty(depth0,"getCustomObjectPosition"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,0,0,{"name":"getCustomObjectPosition","hash":{},"data":data,"loc":{"start":{"line":273,"column":32},"end":{"line":273,"column":66}}}),{"name":"with","hash":{},"fn":container.program(92, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":273,"column":24},"end":{"line":279,"column":33}}})) != null ? stack1 : "")
    + "                      </div>\r\n";
},"92":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <div class=\"container\">\r\n                            <div scope=\"col\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"id") : depth0),{"name":"if","hash":{},"fn":container.program(38, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":275,"column":45},"end":{"line":275,"column":83}}})) != null ? stack1 : "")
    + ">\r\n                              <p class=\"cnx-regular\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"small") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n                            </div>\r\n                          </div>\r\n";
},"94":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"forHB")||(depth0 && lookupProperty(depth0,"forHB"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),0,depth0,1,{"name":"forHB","hash":{},"fn":container.program(95, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":284,"column":20},"end":{"line":323,"column":30}}})) != null ? stack1 : "");
},"95":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n                      <div class=\"row grayscale"
    + container.escapeExpression((lookupProperty(helpers,"getCustomObjectByKey")||(depth0 && lookupProperty(depth0,"getCustomObjectByKey"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[2] != null ? lookupProperty(depths[2],"smallRowProps") : depths[2])) != null ? lookupProperty(stack1,"grayScale") : stack1),depth0,{"name":"getCustomObjectByKey","hash":{},"data":data,"loc":{"start":{"line":286,"column":47},"end":{"line":286,"column":111}}}))
    + "\">\r\n                        <div class=\"small-3 column\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"getCustomArrayElement")||(depth0 && lookupProperty(depth0,"getCustomArrayElement"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[2] != null ? lookupProperty(depths[2],"headings") : depths[2]),depth0,1,"text",{"name":"getCustomArrayElement","hash":{},"data":data,"loc":{"start":{"line":288,"column":34},"end":{"line":288,"column":91}}}),{"name":"with","hash":{},"fn":container.program(96, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":288,"column":26},"end":{"line":298,"column":35}}})) != null ? stack1 : "")
    + "                        </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[2] != null ? lookupProperty(depths[2],"terms") : depths[2]),{"name":"each","hash":{},"fn":container.program(101, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":300,"column":24},"end":{"line":321,"column":33}}})) != null ? stack1 : "")
    + "                      </div>\r\n";
},"96":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <div class=\"container\">\r\n                              <div scope=\"row\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"id") : depth0),{"name":"if","hash":{},"fn":container.program(38, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":290,"column":47},"end":{"line":290,"column":85}}})) != null ? stack1 : "")
    + ">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"small") : depth0),{"name":"if","hash":{},"fn":container.program(97, data, 0),"inverse":container.program(99, data, 0),"data":data,"loc":{"start":{"line":291,"column":32},"end":{"line":295,"column":39}}})) != null ? stack1 : "")
    + "                              </div>\r\n                            </div>\r\n";
},"97":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                  <p  class=\"cnx-regular\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"small") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"99":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                  <p  class=\"cnx-regular\">"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"101":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <div class=\"small-3 column\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"getCustomObjectPosition")||(depth0 && lookupProperty(depth0,"getCustomObjectPosition"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,depths[1],1,{"name":"getCustomObjectPosition","hash":{},"data":data,"loc":{"start":{"line":302,"column":36},"end":{"line":302,"column":76}}}),{"name":"with","hash":{},"fn":container.program(102, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":302,"column":28},"end":{"line":319,"column":37}}})) != null ? stack1 : "")
    + "                          </div>\r\n";
},"102":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                              <div class=\"container\">\r\n                                <div "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"headers") : depth0),{"name":"if","hash":{},"fn":container.program(79, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":304,"column":37},"end":{"line":304,"column":90}}})) != null ? stack1 : "")
    + ">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"linkObj") : depth0)) != null ? lookupProperty(stack1,"small") : stack1),{"name":"if","hash":{},"fn":container.program(103, data, 0, blockParams, depths),"inverse":container.program(105, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":305,"column":34},"end":{"line":316,"column":41}}})) != null ? stack1 : "")
    + "                                </div>\r\n                              </div>\r\n";
},"103":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                    <p class=\"partial-"
    + container.escapeExpression((lookupProperty(helpers,"getCustomObjectKey")||(depth0 && lookupProperty(depth0,"getCustomObjectKey"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depths[1],depths[2],1,{"name":"getCustomObjectKey","hash":{},"data":data,"loc":{"start":{"line":306,"column":54},"end":{"line":306,"column":97}}}))
    + "\">\r\n                                      <span class='ada-hidden'>"
    + container.escapeExpression((lookupProperty(helpers,"getArrayByIndex")||(depth0 && lookupProperty(depth0,"getArrayByIndex"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[4] != null ? lookupProperty(depths[4],"adaHiddenMapping") : depths[4])) != null ? lookupProperty(stack1,"small") : stack1),(data && lookupProperty(data,"index")),{"name":"getArrayByIndex","hash":{},"data":data,"loc":{"start":{"line":307,"column":63},"end":{"line":307,"column":129}}}))
    + "</span>\r\n                                      <span class='update-partial'>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n                                    </p>\r\n                                    <p class=\"custom-link\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"linkObj") : depth0)) != null ? lookupProperty(stack1,"small") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"105":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                                    <p class=\"partial-"
    + container.escapeExpression((lookupProperty(helpers,"getCustomObjectKey")||(depth0 && lookupProperty(depth0,"getCustomObjectKey"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depths[1],depths[2],1,{"name":"getCustomObjectKey","hash":{},"data":data,"loc":{"start":{"line":312,"column":54},"end":{"line":312,"column":97}}}))
    + "\">\r\n                                      <span class='ada-hidden'>"
    + container.escapeExpression((lookupProperty(helpers,"getArrayByIndex")||(depth0 && lookupProperty(depth0,"getArrayByIndex"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[4] != null ? lookupProperty(depths[4],"adaHiddenMapping") : depths[4])) != null ? lookupProperty(stack1,"small") : stack1),(data && lookupProperty(data,"index")),{"name":"getArrayByIndex","hash":{},"data":data,"loc":{"start":{"line":313,"column":63},"end":{"line":313,"column":129}}}))
    + "</span>\r\n                                      <span class='update-partial'>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text") : depth0),{"name":"if","hash":{},"fn":container.program(46, data, 0, blockParams, depths),"inverse":container.program(48, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":314,"column":67},"end":{"line":314,"column":124}}})) != null ? stack1 : "")
    + "</span>\r\n                                    </p>\r\n";
},"107":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <footer>\r\n                <div class='paras'>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"paras") : depth0),{"name":"each","hash":{},"fn":container.program(53, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":332,"column":18},"end":{"line":334,"column":27}}})) != null ? stack1 : "")
    + "                </div>\r\n                <p class=\"link\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"linkObj") : depth0)) != null ? lookupProperty(stack1,"small") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n              </footer>\r\n";
},"109":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rateTooltipContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(110, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":345,"column":6},"end":{"line":347,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"aprTooltipContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(112, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":348,"column":6},"end":{"line":350,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"pointsTooltipContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(114, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":351,"column":6},"end":{"line":353,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"monthlyPaymentsTooltipContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(116, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":354,"column":6},"end":{"line":356,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"fixedTooltipContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(118, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":357,"column":6},"end":{"line":359,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"armTooltipContent") : depth0),{"name":"layerContent","hash":{},"fn":container.program(120, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":360,"column":6},"end":{"line":362,"column":23}}})) != null ? stack1 : "");
},"110":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"rateTooltipContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"112":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"aprTooltipContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"114":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"pointsTooltipContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"116":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"monthlyPaymentsTooltipContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"118":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"fixedTooltipContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"120":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"armTooltipContent") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"mortgage") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":13,"column":7}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1)) != null ? lookupProperty(stack1,"refinance") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":0},"end":{"line":26,"column":7}}})) != null ? stack1 : "")
    + "<div class=\"is-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"language") || (depth0 != null ? lookupProperty(depth0,"language") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"language","hash":{},"data":data,"loc":{"start":{"line":27,"column":15},"end":{"line":27,"column":27}}}) : helper)))
    + "\">\r\n  <div class=\"row show-for-medium-up ratesTableHomeLoansModule rates-table\" class=\"main\">\r\n\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1),{"name":"each","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":4},"end":{"line":144,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n\r\n  <div class=\"row show-for-small-only ratesTableModule rates-table\" class=\"main\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1),{"name":"each","hash":{},"fn":container.program(55, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":148,"column":4},"end":{"line":343,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1),{"name":"with","hash":{},"fn":container.program(109, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":344,"column":4},"end":{"line":363,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>\r\n";
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

/* eslint-disable require-jsdoc */
function arrayLastElement(arr, index) {
  arr.length - 1 === index ? 'last' : '';
}
function objectLastElement(obj, index) {
  Object.keys(obj).length - 1 === index ? 'last' : '';
}
function getArrayByIndex(arr, index) {
  index = parseInt(index); // eslint-disable-line

  try {
    const holder = arr[index].toString();
    return holder;
  } catch (err) {
    return '';
  }
}
function getAdaHiddenMapping(obj, key) {
  try {
    const holder = obj[key].toString();
    return holder;
  } catch (err) {
    return '';
  }
}
function getCustomObjectByKey(obj, key) {
  try {
    const holder = obj[key].toString().toLowerCase();
    return holder;
  } catch (err) {
    return '';
  }
}
function getCustomObjectPosition(obj, keyIndex, add = 0) {
  keyIndex += add; // eslint-disable-line
  let cntr = 0;

  // loop through keys of object
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const key in obj) {
    if (cntr === keyIndex) {
      return obj[key];
    }
    cntr++;
  }
}
function getCustomObjectKey(obj, keyIndex, add = 0) {
  keyIndex += add; // eslint-disable-line
  let cntr = 0;

  // loop through keys of object
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const key in obj) {
    if (cntr === keyIndex) {
      return key;
    }
    cntr++;
  }
}
function forHB(from, to, incr, block) {
  let accum = '';
  for (let i = from; i < to; i += incr) {
    accum += block.fn(i);
  }
  return accum;
}
function ifCond(v1, operator, v2, options) {
  switch (operator) {
    case '==':
      return v1 == v2 ? options.fn(this) : options.inverse(this);
    // eslint-disable-line
    case '===':
      return v1 === v2 ? options.fn(this) : options.inverse(this);
    case '<':
      return v1 < v2 ? options.fn(this) : options.inverse(this);
    case '<=':
      return v1 <= v2 ? options.fn(this) : options.inverse(this);
    case '>':
      return v1 > v2 ? options.fn(this) : options.inverse(this);
    case '>=':
      return v1 >= v2 ? options.fn(this) : options.inverse(this);
    case '&&':
      return v1 && v2 ? options.fn(this) : options.inverse(this);
    case '||':
      return v1 || v2 ? options.fn(this) : options.inverse(this);
    default:
      return options.inverse(this);
  }
}
function getCustomArrayElement(elem, index, add, name = '') {
  const holder = elem[index + add];

  // if string then return string
  if (typeof holder === 'string') {
    return holder;
  } else if (name.length > 0) {
    // if they pass in key and an object then return first value for that key
    return holder[name];
  }
  // if they don't pass in key then return first value for that key
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const key in holder) {
    if (holder.hasOwnProperty(key)) {
      // eslint-disable-line
      return holder[key];
    }
  }
}
function ifArrayLength(arr, length, options) {
  return arr.length === parseInt(length, 10) ? options.fn(this) : options.inverse(this);
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/rates-table-module",
  "version": "4.0.1",
  "id": "ratesTableModule",
  "containerID": "homeLoansRatesTableModule",
  "moduleName": "home-loans-rates-table-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "rates-table-module",
  "data": {
    "init": "ratesTableModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "color",
    "type": "string",
    "values": ["red", "green", "blue"],
    "default": "blue",
    "description": "This parameter controls the general color scheme of module.  The default is blue, but you can choose red or green."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        forHB,
        arrayLastElement,
        objectLastElement,
        getArrayByIndex,
        getAdaHiddenMapping,
        getCustomObjectByKey,
        getCustomObjectPosition,
        getCustomObjectKey,
        ifCond,
        getCustomArrayElement,
        ifArrayLength,
        textInput,
        layerContent,
        is
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    forHB,
    arrayLastElement,
    objectLastElement,
    getArrayByIndex,
    getAdaHiddenMapping,
    getCustomObjectByKey,
    getCustomObjectPosition,
    getCustomObjectKey,
    ifCond,
    getCustomArrayElement,
    ifArrayLength,
    textInput,
    layerContent,
    is
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-input-error-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-validation-framework-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.utilities/sparta-input-utility": "^1.0.0"
  },
  "stores": []
};

// eslint-disable-next-line no-unused-vars

/**
 * @export
 * @class ratesTableModule
 * @extends {Module}
 */
class ratesTableModule extends Module {
  /**
   * @method constructor
   * @param {Object} options MOdule options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    // extend Module
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // Jquery object for wrapper
    if (spaParams.pageParams.ratesTable) {
      if ($('#ratesTableMortgageModule').hasClass('js-init')) {
        this.$target = $('#ratesTableRefinanceModule');
      } else {
        this.$target = $('#ratesTableMortgageModule');
        this.$target.addClass('js-init');
      }
    } else {
      this.$target = $('#ratesTableModule');
    }

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method updateRatesTablePartials
   */
  // eslint-disable-next-line
  updateRatesTablePartials(response) {
    // cache mortgage rates
    const rates = response.data;
    if (!rates) {
      return false;
    }

    // for small calculator (small regular layout) store object of product-name and
    // column number so we can update it below
    const {
      module
    } = rates;
    const $root = module ? $(module) : this.$target;
    let $cache = $root.find('.show-for-small-only .table.small-regular-layout .headings .column');
    const smallProductCodeMappings = {};
    $cache.each((idx, val) => {
      const value = $(val).attr('data-product-code');
      if (value) {
        smallProductCodeMappings[value] = idx;
      }
    });
    if (!rates.mortgageProducts) {
      return false;
    }
    _.each(rates.mortgageProducts, rate => {
      let payment;
      let ratePrice;
      let apr;
      let points;
      if (!(rate && rate.rateDetails)) {
        payment = 'N/A';
        ratePrice = 'N/A';
        apr = 'N/A';
        points = 'N/A';
      } else {
        payment = Math.round(rate.rateDetails.monthlyPayment);
        ratePrice = `${rate.rateDetails.rate.toFixed(3)}%`;
        apr = `${rate.rateDetails.apr.toFixed(3)}%`;
        points = rate.rateDetails.pointsPercentage.toFixed(3);
        payment = `$${this.formatPrice(payment).replace('.00', '')}`;
      }
      let $module = false;
      if (rates.rateInputs.financeType === 1) {
        $module = $('#ratesTableMortgageModule');
      } else if (rates.rateInputs.financeType === 2) {
        $module = $('#ratesTableRefinanceModule');
      }
      if (!spaParams.pageParams.spa) {
        $module = $('#ratesTableModule');
      }

      // for medium calculator and small scroll layout
      $cache = $module.find(`.row[data-product-code="${rate.productCode}"]`);
      $cache.find('.partial-rate').find('.update-partial').text(`${ratePrice}`);
      $cache.find('.partial-apr').find('.update-partial').text(`${apr}`);
      $cache.find('.partial-points').find('.update-partial').text(`${points}`);
      $cache.find('.partial-payment').find('.update-partial').text(`${payment}`);

      // for small calculator regular layout
      const colNum = smallProductCodeMappings[`${rate.productCode}`];
      $cache = $module.find('.show-for-small-only .table.small-regular-layout .row:not(.headings)');
      $cache.each((idx, val) => {
        const value = $(val);
        const colFinder = value.find('.column').eq(colNum);
        colFinder.find('.partial-rate').find('.update-partial').text(`${ratePrice}`);
        colFinder.find('.partial-apr').find('.update-partial').text(`${apr}`);
        colFinder.find('.partial-points').find('.update-partial').text(`${points}`);
        colFinder.find('.partial-payment').find('.update-partial').text(`${payment}`);
      });
    });

    // update effective date
    const {
      getCustomFormattedDate
    } = this;
    this.$target.find('.wrapper-rates-table').each(function tableEach() {
      const $this = $(this);
      const financeType = $this.data('finance-type');
      const {
        rateInputs
      } = rates;
      let milliSecFetched;
      const rateDetails = rates.mortgageProducts;
      for (let i = 0; i < rateDetails.length; i++) {
        if (rateDetails[i].rateDetails && rateDetails[i].rateDetails.rateFetchTimeStamp) {
          milliSecFetched = rateDetails[i].rateDetails.rateFetchTimeStamp;
        }
        if (milliSecFetched) {
          break;
        }
      }
      // only use the date from the rates response for the appropriate loan type
      if (rateInputs.financeType === financeType && milliSecFetched) {
        const dateFetched = new Date(milliSecFetched);
        const $date = $('.rates-table footer .paras .date-time');
        $date.text(getCustomFormattedDate(dateFetched));
      }
    });
    this.$target.find('footer').show();
    this.$target.find('.table').show();
    if ($cache.closest('section.mortgage')) {
      this.$target.find('.partial-price').text(`$${Utility.formatPrice(rates.rateInputs.amountBorrowed)}`);
      this.$target.find('.partial-zip').text(rates.rateInputs.postalCode);
    }
    this.updateAssumptionsLink(rates);
  }

  /**
   * getCustomFormattedDate
   * @param {Date} dt date object
   * @return {String} custom date time
   */
  getCustomFormattedDate(dt) {
    const spanish = /\/es/.test(window.location.pathname);
    // return type is dd mmm yyyy hh:mm am/pm EST
    const monthNames = spanish ? ['de Enero de', 'de Febrero de', 'de Marzo de', 'de Abril de', 'de Mayo de', 'de Junio de', 'de Julio de', 'de Agosto de', 'de Septiembre de', 'de Octubre de', 'de Noviembre de', 'de Diciembre de'] : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = dt.getDate();
    const month = monthNames[dt.getMonth()];
    const year = dt.getFullYear();
    let hour = dt.getHours() % 12;
    hour = hour ? hour : 12; // eslint-disable-line
    const min = dt.getMinutes();
    const amPM = 12 - dt.getHours() > 0 ? 'a.m.' : 'p.m.';
    let timeZone = dt.toString().match(/(\()(.*)(\))/)[2];
    if (spanish) {
      const mappings = {
        eastern: 'hora del este',
        pacific: 'hora del Pacífico',
        central: 'hora del centro',
        mountain: 'hora de la montaña',
        hawaii: 'hora del Hawaii'
      };

      // eslint-disable-next-line
      for (let key in mappings) {
        if (timeZone.toLowerCase().includes(key)) {
          timeZone = mappings[key];
          break;
        }
      }
    }
    return `${this.padString(day)} ${month} ${year} ${this.padString(hour)}:${this.padString(min)} ${amPM} ${timeZone}`;
  }

  /**
   * @name padString
   * @param {String} inp inp
   * @returns {String} pad string
   */
  padString(inp) {
    inp = inp.toString() || ''; // eslint-disable-line
    return inp.trim().length == 1 ? '0' + inp.trim() : inp.trim(); // eslint-disable-line
  }

  /**
   * camelCase
   * @param {String} inp inp
   * @return {String} camelCase
   */
  camelCase(inp) {
    const arr = inp.split('');
    arr[0] = arr[0].toUpperCase();
    return arr.join('');
  }

  /**
   * formatPrice
   * @param {Number} price price
   * @return {String} format price
   */
  formatPrice(price) {
    return price.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  }

  /**
   * @name cleanupInputs
   * @param {String} inp inp
   * @returns {*|type[]|string|String|XML|void} clean up inputs
   */
  cleanupInputs(inp = '') {
    // if undefined show empty string
    // strip anything but character, number, or .
    return inp.replace(/[^A-Za-z0-9.]/g, '');
  }

  /**
   * @method updateArrowPosition
   * @param {Event} e event
   * @desc Updates arrow position for calculator above rate table
   * @returns {void}
   */
  updateArrowPosition(e) {
    // create cache
    const $cache = this.$target.find(e.currentTarget).closest('section');

    // get next image
    const img = $cache.find("[class*='container1']").find('img');

    // get container so we can toggle hide-calc class
    const cont = $cache.find("[class*='container2']");

    // toggle rotate
    img.toggleClass('rotate-up').toggleClass('rotate-down');

    // slide toggle for container
    cont.slideToggle();

    // toggle hide-calc class so we know whether it's hidden or not
    cont.toggleClass('hide-calc');
  }

  /**
   * @name addSoftErrors
   * @param {jQuery} $input input jQuery
   * @desc Add appropriate soft error class so user sees warning message
   * @return {void}
   */
  addSoftErrors($input) {
    $input.siblings('label').attr('style', 'color: green !important');
    $input.siblings('.spa-input-error-message').addClass('soft-error');
    $input.closest('.spa-input').addClass('validation-input-green');
    const viewport = this.Store.getData('currentMQ').viewport === 'small' ? 'small' : 'medium';
    $(`#down-payment-input-${viewport}`).blur();
    $(`#down-payment-input-${viewport}_errorMessage`).focus();
    $(`#loan-amount-input-${viewport}`).blur();
    $(`#loan-amount-input-${viewport}_errorMessage`).focus();
  }

  /**
   * @name removeSoftErrors
   * @param {jQuery} $input input
   * @return {void}
   */
  removeSoftErrors($input) {
    $input.siblings('label').removeAttr('style');
    $input.siblings('.spa-input-error-message').removeClass('soft-error');
    $input.closest('.spa-input').removeClass('validation-input-green');
    const viewport = this.Store.getData('currentMQ').viewport === 'small' ? 'small' : 'medium';
    $(`#down-payment-input-${viewport}_errorMessage`).blur();
    $(`#loan-amount-input-${viewport}_errorMessage`).blur();
  }

  /**
   * @name additionalValidate
   * @param {Event} e event
   * @desc Add soft errors
   * @returns {void}
   */
  additionalValidate(e) {
    const $input = this.$target.find(e.currentTarget);
    const id = $input.attr('id');
    if (/purchase-price/.test(id) || /home-value/.test(id)) {
      const viewport = this.Store.getData('currentMQ').viewport === 'small' ? 'small' : 'medium';
      const $downPaymentInput = this.$target.find(`#down-payment-input-${viewport}`);
      const $loanAmountInput = this.$target.find(`#loan-amount-input-${viewport}`);
      if ($downPaymentInput.val() || $loanAmountInput.val()) {
        this.customValidation($downPaymentInput.length && $downPaymentInput.val() ? $downPaymentInput : $loanAmountInput);
      }
    }
  }

  /**
   * @name markDataBlur
   * @param {Event} e event
   * @desc Add data blur attr
   * @returns {void}
   */
  markDataBlur(e) {
    const $cache = this.$target.find(e.currentTarget);

    // add blur data attr
    $cache.attr('data-blur', 'true');
  }

  /**
   * @name customValidation
   * @param {jQuery} $inputs input jQuery
   * @returns {boolean} validation
   */
  customValidation($inputs) {
    const $validatedInputs = $inputs || this.$target.find('input[data-validation-rules]:visible');
    const self = this;
    const customResults = $validatedInputs.map(function validationInputMap() {
      const $input = $(this);
      const data = $input.data('validation-rules');
      const eventNames = Object.keys(data);
      const results = eventNames.map(eventName => {
        const customRules = data[eventName].custom;
        if (customRules) {
          const field = {
            field: $input,
            label: $input.siblings('label')
          };
          self.removeSoftErrors($input);
          spartaInputErrorUtility.updateInlineError(false, field);
          let errorFound = false;
          const results = customRules.map(rule => {
            // eslint-disable-line
            const fn = self[rule.fn];
            const isValid = fn.call(self, $input, ...rule.parameters);
            if (!errorFound) {
              if (!isValid) {
                errorFound = true;
                spartaInputErrorUtility.updateInlineError(true, Object.assign(field, {
                  message: rule.errorMessage
                })).then(() => {
                  if (rule.soft && $input.val() !== '') {
                    self.addSoftErrors($input);
                  }
                });
              }
            }
            return rule.soft ? 'soft' : isValid;
          });
          return !_.some(results, val => !val) && _.some(results, val => val === 'soft') ? 'soft' : _.every(results);
        }
        return true;
      });
      return !_.some(results, val => !val) && _.some(results, val => val === 'soft') ? 'soft' : _.every(results);
    });
    const {
      validationCore
    } = this;
    const allRequiredValuesProvided = _.filter(customResults.map((idx, val) => {
      // eslint-disable-line
      const $input = $($validatedInputs[idx]);
      // if either the input doesn't have a value or
      // it has passed all previous validations, go ahead and run this validation
      if (!$input.val() || val === true) {
        return validationCore.validateRequiredFields($input);
      }
    }), val => typeof val !== 'undefined');
    const {
      validationRules
    } = this;
    const validationResults = _.filter(customResults.map((idx, val) => {
      // eslint-disable-line
      // if there aren't already validation errors, go ahead and run the standard validations
      if (val === true) {
        const $input = $($validatedInputs[idx]);
        const fieldValidations = validationRules[$input.attr('id')];
        const events = Object.keys(fieldValidations);
        const allRules = _.reduce(events, (memo, event) => Object.assign(memo, fieldValidations[event]), {});
        return validationCore.validateRules($input, allRules);
      }
    }), val => typeof val !== 'undefined');
    const allResults = [...allRequiredValuesProvided, ...validationResults, ...customResults];
    return !_.isEmpty(allResults) && _.every(allResults, result => [true, 'soft'].indexOf(result) !== -1);
  }

  /**
   * @name ratesUpdateClicked
   * @param {Event} e
   * @returns {void}
   */
  // eslint-disable-next-line
  ratesUpdateClicked(e) {
    // stop prevent default
    e.preventDefault();
    const mortgageProducts = [];

    // collect viewport
    // eslint-disable-next-line no-constant-condition
    let {
      viewport
    } = this.Store.getData('currentMQ');
    if (viewport === 'small' || viewport === 'smallMid' || viewport === 'smallPlus') {
      viewport = 'small';
    } else {
      viewport = 'medium';
    }

    // get container2 closest to the holder
    const $wrapper = this.$target.find(`.${viewport}-container2`);

    // get main calculator selector
    const $calculator = this.$target.find(`.${viewport}-calculator`);

    // get table selector
    const $table = $calculator.next();

    // get correct table information
    const $tableInformation = viewport === 'small' ? $table.find('.column[data-product-code]') : $table.find('.row[data-product-code]');

    // custom parsely events
    const validated = this.customValidation();
    console.log('VALIDATED', validated);

    // $('#down-payment-input-'+viewport).blur();
    // $('#down-payment-input-'+viewport+'_errorMessage').css('border','1px solid green');
    // if validated fails stop func
    if (!validated) {
      return false;
    }

    // Loop through rows to get products
    $.each($tableInformation, (index, $cache) => {
      // wrap in selector
      $cache = $($cache); // eslint-disable-line

      // push to array
      mortgageProducts.push({
        productCode: $cache.data('productCode'),
        productSubCode: $cache.data('productSubCode'),
        productName: $cache.data('productName')
      });
    });

    // extract zip code
    let zipCode = this.cleanupInputs($wrapper.find(`#zip-code-input-${viewport}`).val());
    const $zipCodeRefinance = $wrapper.find(`#zip-code-refinance-input-${viewport}`);
    const zipCodeRefinance = this.cleanupInputs($zipCodeRefinance.val());
    zipCode = $zipCodeRefinance.is(':visible') ? zipCodeRefinance.slice(0, 5) : zipCode.slice(0, 5);

    // extract down payment
    const downPayment = Math.round(this.cleanupInputs($wrapper.find(`#down-payment-input-${viewport}`).val()));

    // extract purchase price
    let purchasePrice = Math.round(this.cleanupInputs($wrapper.find(`#purchase-price-input-${viewport}`).val()));

    // extract home value
    const homeValue = Math.round(this.cleanupInputs($wrapper.find(`#home-value-input-${viewport}`).val()));

    // extract purchase price
    const loanAmount = Math.round(this.cleanupInputs($wrapper.find(`#loan-amount-input-${viewport}`).val()));

    // calculate amount borrowed
    const amountBorrowed = loanAmount || purchasePrice - downPayment;
    if (homeValue) purchasePrice = homeValue;

    // public rates table update
    this.Events.pub('HOME_LOANS_RATES_TABLE_CALCULATOR_SUBMIT', {
      rateInputs: {
        purchasePrice,
        amountBorrowed,
        downPayment,
        postalCode: zipCode
      }
    });

    // public rates table update
    this.Events.pub('HOME_LOANS_OVERVIEW_RATES_TABLE_CALCULATOR_SUBMIT', {
      rateInputs: {
        purchasePrice,
        amountBorrowed,
        downPayment,
        postalCode: zipCode
      }
    });
  }

  /**
   *
   * @name formatNumber
   * @param {String} str string
   * @return {*|type[]|string|String} number
   */
  formatNumber(str) {
    // strip $ and space and comma
    str = str.replace(/\s+/g, '').replace(/,/g, '').replace('$', ''); // eslint-disable-line
    if (isNaN(str) || str == '') {
      // eslint-disable-line
      return 0;
    }
    return parseFloat(str);
  }

  /**
   * @name windowResize
   * @desc Brings data from/to medium/small screens when window is resized
   * @returns {void}
   */
  windowResize() {
    // determine what viewport we're on
    const viewport = this.Store.getData('currentMQ').viewport === 'small' ? 'small' : 'medium';

    // define opposites
    const opposite = {
      small: 'medium',
      medium: 'small'
    };

    // define query
    const query = viewport === 'small' ? this.$target.find('.row.show-for-medium-up') : this.$target.find('.row.show-for-small-only');

    // viewport opposite
    const viewportOpposite = opposite[viewport];

    // get opposite fields
    const zipCode = this.cleanupInputs(query.find(`#zip-code-input-${viewportOpposite}`).val());
    const zipCodeRefinance = this.cleanupInputs(query.find(`#zip-code-refinance-input-${viewportOpposite}`).val());
    const downPayment = this.cleanupInputs(query.find(`#down-payment-input-${viewportOpposite}`).val());
    const purchasePrice = this.cleanupInputs(query.find(`#purchase-price-input-${viewportOpposite}`).val());
    const homeValue = this.cleanupInputs(query.find(`#home-value-input-${viewportOpposite}`).val());
    const loanAmount = this.cleanupInputs(query.find(`#loan-amount-input-${viewportOpposite}`).val());

    // if we changed viewports
    if (this.globalVars.oldScreen !== viewport) {
      // get fields in new view
      const currZipCode = this.$target.find(`.${viewport}-container2`).find(`#zip-code-input-${viewport}`).val();
      const currZipCodeRefinance = this.$target.find(`.${viewport}-container2`).find(`#zip-code-refinance-input-${viewport}`).val();
      const currDownPayment = this.$target.find(`.${viewport}-container2`).find(`#down-payment-input-${viewport}`).val();
      const currPurchasePrice = this.$target.find(`.${viewport}-container2`).find(`#purchase-price-input-${viewport}`).val();
      const currHomeValue = this.$target.find(`.${viewport}-container2`).find(`#home-value-input-${viewport}`).val();
      const currLoanAmount = this.$target.find(`.${viewport}-container2`).find(`#loan-amount-input-${viewport}`).val();

      // set values

      try {
        if (purchasePrice) {
          currPurchasePrice.val(purchasePrice).focusin().blur();
        }
        if (zipCode) {
          currZipCode.val(zipCode).focusin().blur();
        }
        if (zipCodeRefinance) {
          currZipCodeRefinance.val(zipCodeRefinance).focusin().blur();
        }
        if (downPayment) {
          currDownPayment.val(downPayment).focusin().blur();
        }
        if (homeValue) {
          currHomeValue.val(homeValue).focusin().blur();
        }
        if (loanAmount) {
          currLoanAmount.val(loanAmount).focusin().blur();
        }
      } catch (e) {
        this.globalVars.oldScreen = viewport;
      }
    }

    // set global variable to new current viewport
    this.globalVars.oldScreen = viewport;
  }

  /**
   * @name updateAssumptionsLink
   * @desc add preferred rewards query parameters to assumptions link
   * @param {Object} rates rates obj
   * @returns {void}
   */
  updateAssumptionsLink(rates) {
    const zipcode = rates.rateInputs.postalCode;
    const {
      purchasePrice,
      downPayment
    } = rates.rateInputs;
    const $links = this.$target.find('.loan-assumptions-disclosures');
    const route = rates && rates.route;
    const url = route ? spaParams.siteParams.assumptionsLink[route] : spaParams.pageParams.assumptions;
    const loanTypeMapping = {
      mortgage: 'mortgage',
      refinance: 'refinance',
      'home-equity': 'homeEquity'
    };
    const loanType = loanTypeMapping[route] || spaParams.pageParams.loanType;
    const matches = window.location.pathname.match(/\/(\w{2}\/)$/);
    const language = matches ? matches[1] : '';
    $links.each(function linksEach() {
      const $link = $(this);
      const options = $link.data('options') || {};
      const {
        productCode
      } = options;
      const section = productCode ? `#product${productCode}` : '';
      $link.attr('href', `${url}${language}?purchasePrice=${purchasePrice}&downPayment=${downPayment}&zipcode=${zipcode}&loanType=${loanType}${section}`);
    });
  }

  /**
   * @name showCalculatorOnly
   * @param {Object} response response obj
   * @return {undefined} show calculation
   */
  showCalculatorOnly(response) {
    const rates = response.data;
    this.finishLoading();
    this.$target.find('.table').hide();
    this.$target.find('footer').hide();
    if (!rates.rateInputs) {
      return;
    }
    if (['mortgage', 'refinance'].includes(rates.route)) {
      const amountBorrowed = Utility.formatPrice(rates.rateInputs.amountBorrowed);
      this.$target.find('.partial-price').text(`$${amountBorrowed}`);
      this.$target.find('.partial-zip').text(`${rates.rateInputs.postalCode}`);
    }
  }

  /**
   * @name smallScrollLayout
   * @param {Event} e event
   * @returns {void}
   */
  smallScrollLayout(e) {
    const $cache = this.$target.find(e.currentTarget);
    const table = $cache.closest('.table');
    if (table.hasClass('left-show')) {
      table.toggleClass('margin-animate');
      table.removeClass('left-show').addClass('right-show');
      table.find('.side-click-right').hide();
      setTimeout(() => {
        table.find('.side-click-left').show();
      }, 800);
    } else {
      table.toggleClass('margin-animate');
      table.removeClass('right-show').addClass('left-show');
      table.find('.side-click-left').hide();
      setTimeout(() => {
        table.find('.side-click-right').show();
      }, 800);
    }
  }

  /**
   * @param {Object} response response
   * @returns {void}
   */
  fadeInRatesFallBack(response) {
    const $cache = $(response.data.id);
    $cache.fadeIn({
      duration: 200,
      easing: 'linear'
    });
  }

  /**
   * @param {Object} response response
   * @returns {void}
   */
  fadeOutRatesFallBack(response) {
    const $cache = $(response.data.id);
    $cache.fadeOut({
      duration: 200,
      easing: 'linear'
    });
  }

  /**
   * @returns {void}
   */
  startLoading() {
    this.$target.find('.spin').addClass('spinner');
  }

  /**
   * @returns {void}
   */
  finishLoading() {
    this.$target.find('.spin').removeClass('spinner');
  }

  /**
   * @param {String} val string
   * @return {Number} Number
   */
  numberIfy(val) {
    return Number(val.replace(/[^\d\.]/g, '')); // eslint-disable-line
  }

  /**
   * @param {jQuery} $input jQuery input
   * @param {HTMLElement} otherInput other input
   * @param {Number} minPercentage minimum percentage
   * @return {boolean}  less than percentage of
   */
  lessThanPercentageOf($input, otherInput, minPercentage) {
    const value = this.numberIfy($input.val());
    const otherValue = this.numberIfy($(otherInput).val());
    const percentage = 100 * (value / otherValue);
    return percentage >= minPercentage;
  }

  /**
   * @param {jQuery} $input jQuery input
   * @param {HTMLElement} otherInput other input
   * @param {Number} minPercentage minimum percentage
   * @param {Number} maxPercentage maximum percentage
   * @return {boolean} within percentage of
   */
  withinPercentageOf($input, otherInput, minPercentage, maxPercentage) {
    const value = this.numberIfy($input.val());
    const otherValue = this.numberIfy($(otherInput).val());
    const percentage = 100 * (value / otherValue);
    return percentage >= minPercentage && percentage >= maxPercentage;
  }

  /**
   * @param {jQuery} $input jQuery input
   * @param {HTMLElement} otherInput other input
   * @param {Number} minPercentage minimum percentage
   * @param {Number} maxPercentage maximum percentage
   * @return {boolean} within percentage range of
   */
  withinPercentageRangeOf($input, otherInput, minPercentage, maxPercentage) {
    const value = this.numberIfy($input.val());
    const otherValue = this.numberIfy($(otherInput).val());
    const percentage = 100 * (value / otherValue);
    return percentage >= minPercentage && percentage <= maxPercentage;
  }

  /**
   * @param {jQuery} $input jQuery input
   * @param {Number} min minimum
   * @param {Number} max maximum
   * @return {boolean} within rage
   */
  withinRange($input, min, max) {
    const value = this.numberIfy($input.val());
    return value >= min && value <= max;
  }

  /**
   * @param {jQuery} $input jQuery input
   * @param {HTMLElement} otherInput other input
   * @return {boolean} less than
   */
  lessThanField($input, otherInput) {
    const value = this.numberIfy($input.val());
    const otherValue = this.numberIfy($(otherInput).val());
    return value < otherValue;
  }

  /**
   *
   *
   * @param {jQuery} $input jQuery input
   * @param {HTMLElement} otherInput other input
   * @return {boolean} less than or equal to field
   */
  lessThanOrEqualToField($input, otherInput) {
    const value = this.numberIfy($input.val());
    const otherValue = this.numberIfy($(otherInput).val());
    return value <= otherValue;
  }

  /**
   * @param {jQuery} $input jQuery input
   * @param {HTMLElement} otherInput other input
   * @param {Number} min minimum
   * @param {Number} max maximum
   * @return {boolean} difference within range
   */
  differenceWithinRange($input, otherInput, min, max) {
    const value = this.numberIfy($input.val());
    const otherValue = this.numberIfy($(otherInput).val());
    const difference = otherValue - value;
    return difference >= min && difference <= max;
  }

  /**
   * @return {void}
   */
  initializeSpartaValidationRules() {
    const $validatedInputs = this.$target.find('input[data-validation-rules]');

    // eslint-disable-next-line
    const validationRules = this.validationRules = _.fromPairs($validatedInputs.map(function () {
      const $input = $(this);
      const data = $input.data('validation-rules');
      const eventNames = Object.keys(data);
      const events = eventNames.map(eventName => [eventName, _.omit(data[eventName], ['custom'])]);
      return [[$input.attr('id'), _.fromPairs(_.filter(events))]];
    }));

    // eslint-disable-next-line
    const validationCore = this.validationCore = spartaValidationFramework.fn.core;
    validationCore.bindValidationRules(validationRules, true);

    // separate handling of "required" validations
    this.$target.find('input[required]').each(function requiredInoutEach() {
      const $input = $(this);
      $input.on('blur', () => {
        if (!$input.val()) {
          validationCore.validateRequiredFields($input);
        }
      });
    });
    const self = this;
    $validatedInputs.each(function validateInputEach() {
      const $input = $(this);
      const data = $input.data('validation-rules');
      const eventNames = Object.keys(data);
      eventNames.forEach(eventName => {
        const customRules = data[eventName].custom;
        if (customRules) {
          $input.on(eventName, () => {
            self.customValidation($input);
          });
        }
      });
    });
  }

  /**
   * @name init
   * @desc Initialize module
   * @returns {void}
   */
  init() {
    this.globalVars = {
      oldScreen: this.Store.getData('currentMQ').viewport === 'small' ? 'small' : 'medium'
    };

    // MORTGAGE PAGE
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS', this.updateRatesTablePartials);
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS', this.fadeOutRatesFallBack);
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS', this.finishLoading);
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE', this.showCalculatorOnly);
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE', this.fadeInRatesFallBack);

    // REFINANCE PAGE
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS', this.updateRatesTablePartials);
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS', this.fadeOutRatesFallBack);
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS', this.finishLoading);
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE', this.showCalculatorOnly);
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE', this.fadeInRatesFallBack);

    // MORTGAGE OVERVIEW MORTGAGE TAB
    this.Events.sub('HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS', this.updateRatesTablePartials);
    this.Events.sub('HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS', this.fadeOutRatesFallBack);
    this.Events.sub('HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS', this.finishLoading);
    this.Events.sub('HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE', this.showCalculatorOnly);
    this.Events.sub('HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE', this.fadeInRatesFallBack);

    // MORTGAGE OVERVIEW REFINANCE TAB
    this.Events.sub('HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS', this.updateRatesTablePartials);
    this.Events.sub('HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS', this.fadeOutRatesFallBack);
    this.Events.sub('HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS', this.finishLoading);
    this.Events.sub('HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE', this.showCalculatorOnly);
    this.Events.sub('HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE', this.fadeInRatesFallBack);

    // MORTGAGE OVERVIEW HOME EQUITY TAB
    this.Events.sub('HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS', this.updateRatesTablePartials);
    this.Events.sub('HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS', this.fadeOutRatesFallBack);
    this.Events.sub('HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS', this.finishLoading);
    this.Events.sub('HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE', this.showCalculatorOnly);
    this.Events.sub('HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE', this.fadeInRatesFallBack);

    // SUBMITS
    this.Events.sub('HOME_LOANS_ZIP_CODE_CHANGE_SUBMIT', this.startLoading);
    this.Events.sub('HOME_LOANS_RATES_TABLE_CALCULATOR_SUBMIT', this.startLoading);
    this.Events.sub('HOME_LOANS_OVERVIEW_RATES_TABLE_CALCULATOR_SUBMIT', this.startLoading);

    // Start up sparta global inputs
    this.$target.spartaInputs({
      validate: true
    });

    // Red October validation rules
    this.initializeSpartaValidationRules();

    // Controls Arrow dropdown
    this.$target.find('.small-container1 a, .small-container1 img, .medium-container1 a, .medium-container1 img').on('click', _.debounce(this.updateArrowPosition, 200));

    // user select cancel
    this.$target.find('a#cancel-mortgage-rates-medium, a#cancel-mortgage-rates-small').on('click', _.debounce(this.updateArrowPosition, 200));

    // Update rates button is clicked
    this.$target.find('.small-container2 #update-button-small, .medium-container2 #update-button-medium').on('click', this.ratesUpdateClicked);
    this.$target.find('.small-container2 #update-button-small, .medium-container2 #update-button-medium').on('keyup', e => {
      if (e.keyCode === 13) {
        this.ratesUpdateClicked.bind(this)(e);
      }
    });
    this.$target.find('form input').on('blur', _.debounce(this.additionalValidate, 500));
    this.$target.find('form input').on('blur', this.additionalValidate);
    this.$target.find('form input').on('blur focusout', this.markDataBlur);

    // on resize move input elements to appropriate viewport
    $(window).resize(this.windowResize);

    // click on small scroll layout div/chevrons
    this.$target.find('div[class*="side-click"]').on('click', this.smallScrollLayout);
  }
}
registerModuleClass({
  moduleClass: ratesTableModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ratesTableModule as default, moduleConfig };
